import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import ProjectLastUpdatedOn from "components/ProjectLastUpdatedOn";
import { useGetLastUpdatedOnStatusQuery } from "store/slices/apis/projectStatusApiSlice";
import LeaseKpi from "./LeaseKpi";
import TargetActualSqftChart from "./TargetActualSqftChart";
import ActiveLeadsMixByTemperature from "./ActiveLeadsMixByTemperature";
import { useGetLeaseDataQuery } from "store/slices/apis/leaseDashboardSlice";
import AverageTimeToDealChart from "./AverageTimeToDealChart";
import AssetTypeStackedChart from "./AssetTypeStackedChart";
import LeadFunnelChart from "./LeadFunnelChart";
import { enterpriseTokens } from "styles/theme";

const LeaseDashboard = () => {
  const { projectId } = useParams();
  const { data: data, isFetching: loading, isError: error } = useGetLeaseDataQuery({ projectId });
  const { data: leaseData } = useGetLastUpdatedOnStatusQuery({ ProjectId: projectId });

  return (
    <>
      <Grid container spacing={"10px"} sx={{ p: 0, pb: 6 }}>
        <Grid size={12} sx={{ bgcolor: "#fff", p: 2, pt: 2 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: { xs: "column", md: "row" },
                gap: 1,
              }}
            >
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "18px", sm: "32px", md: "36px" },
                  lineHeight: { xs: "16px", md: "48px" },
                  color: "#252C32",
                  fontFamily: "Outfit, sans-serif",
                }}
              >
                Leasing Performance
              </Typography>
            </Box>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "24px",
                color: "#252C32",
                fontFamily: "Outfit, sans-serif",
              }}
            >
              Monitor lead conversion, deal velocity, leased area, and commercial pipeline health.
            </Typography>
          </Box>
        </Grid>
        <Grid size={12} sx={{ px: 2 }}>
          <Box sx={{ display: "flex", justifyContent: "flex-end", pb: 0.75, borderBottom: `1px solid ${enterpriseTokens.lineSoft}`, "& .MuiTypography-root": { fontSize: "12px", color: enterpriseTokens.muted } }}>
            <ProjectLastUpdatedOn date={leaseData?.lease} />
          </Box>
        </Grid>
        <Grid container columnSpacing={1.5} rowSpacing={1.5} sx={{ px: 2 }}>
          <Grid size={{ xs: 12, md: 9 }}>
            <LeaseKpi data={data?.data} isError={error} isLoading={loading} />
          </Grid>
          <Grid size={{ xs: 12, md: 3 }}>
            <AverageTimeToDealChart data={data?.data} isError={error} isLoading={loading} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <TargetActualSqftChart data={data?.data} isError={error} isLoading={loading} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <ActiveLeadsMixByTemperature data={data?.data} isError={error} isLoading={loading} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <AssetTypeStackedChart data={data?.data} isError={error} isLoading={loading} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <LeadFunnelChart data={data?.data} isError={error} isLoading={loading} />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default LeaseDashboard;
